// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__9r_j2","split":"Info_split__fl9Du","ourOpeningHours":"Info_ourOpeningHours__1h8gr"};